import { Controller } from "@hotwired/stimulus"

const TRAINING_PATH_PATTERN = /^\/(?:formations(?:\/|$)|formation-(?:osteopathe|kinesitherapeute|podologue)(?:\/|$))/

export default class extends Controller {
  track (event) {
    if (!(event.target instanceof Element)) return

    const link = event.target.closest("a[href]")
    if (!link || !this.element.contains(link)) return

    const url = new URL(link.href, window.location.origin)
    if (url.origin !== window.location.origin || !TRAINING_PATH_PATTERN.test(url.pathname)) return

    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({
      event: "blog_training_link_click",
      source_path: window.location.pathname,
      target_path: url.pathname,
      link_position: this.trainingLinks().indexOf(link) + 1
    })
  }

  trainingLinks () {
    return Array.from(this.element.querySelectorAll("a[href]")).filter((link) => {
      const url = new URL(link.href, window.location.origin)

      return url.origin === window.location.origin && TRAINING_PATH_PATTERN.test(url.pathname)
    })
  }
}
